import { render, staticRenderFns } from "./AddSchool.vue?vue&type=template&id=61310e71&scoped=true&"
import script from "./AddSchool.vue?vue&type=script&lang=js&"
export * from "./AddSchool.vue?vue&type=script&lang=js&"
import style0 from "./AddSchool.vue?vue&type=style&index=0&id=61310e71&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61310e71",
  null
  
)

export default component.exports